import { __decorate } from "tslib";
import Component from "vue-class-component";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import TemplateContent from "@/components/template/TemplateContent.vue";
import CompetitionForm from "@/components/CompetitionForm.vue";
let CompetitionAdd = class CompetitionAdd extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.name = "";
        this.location = "";
        this.link = "";
        this.date = null;
        this.boards = Array();
        this.submitTask = Task.idle();
    }
    submit() {
        const competitionsListQuery = require("@/apollo/queries/competitionsList.graphql");
        this.subscribeMutation({
            tag: "submit",
            options: {
                mutation: require("@/apollo/mutations/addCompetition.graphql"),
                variables: {
                    name: this.name,
                    location: this.location,
                    link: this.link,
                    start: this.date.start,
                    end: this.date.end,
                    boards: this.boards.map(it => ({
                        board_id: it
                    }))
                },
                update: (store, { data }) => {
                    try {
                        const competitionsListData = store.readQuery({ query: competitionsListQuery });
                        competitionsListData.competitions.push(data.insert_competitions.returning[0]);
                        store.writeQuery({
                            query: competitionsListQuery,
                            data: competitionsListData
                        });
                    }
                    catch (e) {
                        console.log("Failed to update cache after insert_competitions mutation");
                        console.log(e);
                    }
                }
            },
            onTask: task => {
                this.submitTask = task;
                if (task.isSuccessful) {
                    this.$router.push({ name: "competitions_list" });
                }
            }
        });
    }
};
CompetitionAdd = __decorate([
    Component({
        components: { CompetitionForm, TemplateContent }
    })
], CompetitionAdd);
export default CompetitionAdd;
